// extracted by mini-css-extract-plugin
export default {"calling":"Calling_calling__9Q5Rm","backButton":"Calling_backButton__IC-kF"};